<template>
<div style="width: 1200px;margin: auto;">
 <section class="section process-section" style=" ">
      <div class="container">
        <div class="section-label">USING PROCESSES</div>
        <h2 class="section-heading">福利卡使用流程</h2>

        <div class="process-steps">
          <div class="process-item">
            <div class="process-card">
              <img class="process-icon" src="../assets/1.png" alt="关注公众号">
            </div>
            <div class="process-name">关注公众号</div>
            <div class="process-desc">关注微信公众号“悦享聚汇”，选择【悦享臻选】板块</div>
          </div>
          <div class="process-arrow">›</div>
          <div class="process-item">
            <div class="process-card">
              <img class="process-icon" src="../assets/2.png" alt="进入悦享蛋糕">
            </div>
            <div class="process-name">进入悦享商城</div>
            <div class="process-desc">进入悦享商城登陆账号，选择福利卡进行绑定</div>
          </div>
          <div class="process-arrow">›</div>
          <div class="process-item">
            <div class="process-card">
              <img class="process-icon" src="../assets/3.png" alt="绑定福利卡">
            </div>
            <div class="process-name">绑定福利卡</div>
            <div class="process-desc">扫描二维码或输入卡号、密码完成超级卡的绑定</div>
          </div>
          <div class="process-arrow">›</div>
          <div class="process-item">
            <div class="process-card">
              <img class="process-icon" src="../assets/4.png" alt="选择心仪商品">
            </div>
            <div class="process-name">选择心仪商品</div>
            <div class="process-desc">选择商品加入购物车进行下单，可通过我的订单查询信息</div>
          </div>
        </div>
      </div>
    </section>

</div>
</template>

<script>
export default {
  name: 'ComsPross',
  data() {
    return {
        categories: [
        { name: '粮油副食', desc: '品质优选，一站配齐', img: '//34188381.s21i.faiusr.com/2/ABUIABACGAAgypmnzwYowPTN7wYw7gU4tQk!450x450.jpg' },
        { name: '清洁好物', desc: '一擦焕新超省心的清洁好帮手', img: '//34188381.s21i.faiusr.com/2/ABUIABACGAAgqZunzwYogKKXsAYw4AU4nAo!450x450.jpg' },
        { name: '家用电器', desc: '经久耐用、智能高效', img: '//34188381.s21i.faiusr.com/2/ABUIABACGAAg95ynzwYoh_Op3gEwkg44ihI!450x450.jpg' }
      ],
      fourTypes: [
        { name: '生日蛋糕  悦享美味', img: '//34188381.s21i.faiusr.com/4/ABUIABAEGAAg1KanzwYopPO8xAYwyAE4yAE.png' },
        { name: '电影演出  悦享影音', img: '//34188381.s21i.faiusr.com/4/ABUIABAEGAAgi6mnzwYonpT9ugcwyAE4yAE.png' },
        { name: '图书频道  悦享知识', img: '//34188381.s21i.faiusr.com/4/ABUIABAEGAAgkqunzwYolJ7SwgQwyAE4yAE.png' },
        { name: '景区门票  悦享休闲', img: '//2.ss.508sys.com/image/materialLib/other/500000160.png' }
      ],
      flowSteps: [
        { title: '关注公众号', desc: '关注微信公众号"悦享聚汇"，选择【悦享臻选】板块', img: require('../assets/1.png'), },
        { title: '进入悦享商城', desc: '进入悦享商城登陆账号，选择福利卡进行绑定', img: require('../assets/2.png'), },
        { title: '绑定福利卡', desc: '输入卡号、密码或扫描二维码完成超级卡的绑定', img: require('../assets/3.png'), },
        { title: '选择心仪商品', desc: '选择商品加入购物车进行下单，可通过我的订单查询信息', img: require('../assets/4.png'), }
      ]
    }
  },
  methods: {
    
  }
}
</script>

<style scoped>
 
/* ========== 福利卡使用流程（新版） ========== */
.process-section {
  padding: 60px 0;
  margin-top: 0;
}

.section-label {
  text-align: center;
  color: #e5e5e5;
  font-size: 36px;
  font-weight: bold;
}

.section-heading {
  text-align: center;
  color: #353535;
  font-size: 36px;
  font-weight: bold;
  margin-bottom: 50px;
}

.process-steps {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  gap: 0;
  margin-top: 50px;
  padding-bottom: 50px;
}

.process-item {
  text-align: center;
  width: 25%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.process-card {
  width: 125px;
  height: 125px;
  margin: 0 auto 30px;
  flex-shrink: 0;
}

.process-icon {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.process-item-text {
  width: 100%;
  padding: 0 10px;
}

.process-name {
  font-size: 16px;
  font-weight: bold;
  color: #000;
  margin-bottom: 10px;
}

.process-desc {
  font-size: 14px;  padding:  0 50px;
  color: #666;
  line-height: 1.6;
  word-break: break-word;
}

.process-arrow {
  font-size: 32px;
  color: #ccc;
  margin-top: 50px;
  flex-shrink: 0;
}

/* ========== 响应式设计 ========== */
@media (max-width: 1024px) {
  .pro-banner {
    height: 500px;
  }
  
  .section-label {
    font-size: 28px;
  }
  
  .section-heading {
    font-size: 28px;
    margin-bottom: 35px;
  }
  
  .category-grid {
    gap: 60px;
  }
  
  .four-grid {
    gap: 50px;
    flex-wrap: wrap;
  }
  
  .four-item {
    width: 150px;
  }
}

@media (max-width: 768px) {
  .pro-banner {
    height: 300px;
  }
  
  /* 悦享超级卡介绍 */
  .content-block {
    flex-direction: column;
    align-items: center;
  }
  
  .content-img {
    width: 180px;
    margin-bottom: 20px;
  }
  
  .content-text {
    text-align: center;
  }
  
  .content-text h2 {
    font-size: 18px;
  }
  
  .content-text h3 {
    font-size: 18px;
  }
  
  .content-text p {
    font-size: 14px;
    line-height: 1.8;
  }
  
  /* 全品类覆盖 */
  .category-grid {
    flex-direction: column;
    align-items: center;
    gap: 30px;
  }
  
  .category-item {
    width: 100%;
    max-width: 350px;
  }
  
  .category-item img {
    height: 350px;
  }
  
  .category-overlay {
    bottom: 20px;
    width: 85%;
  }
  
  .cate-line {
    width: 120px;
    margin: 10px auto;
  }
  
  /* 四大品类 */
  .four-grid {
    gap: 30px;
    flex-wrap: wrap;
  }
  
  .four-item {
    width: calc(50% - 30px);
    min-width: 140px;
  }
  
  .four-item img {
    height: 150px;
  }
  
  .four-name {
    font-size: 16px;
  }
  
  /* 福利卡使用流程 - 移动端优化 */
  .process-section {
    padding: 40px 0;
  }
  
  .section-label {
    font-size: 22px;
  }
  
  .section-heading {
    font-size: 22px;
    margin-bottom: 25px;
  }
  
  .process-steps {
    flex-direction: column;
    align-items: center;
    gap: 15px;
    margin-top: 30px;
  }
  
  .process-item {
    width: 100%;
    max-width: 320px;
    flex-direction: row;
    align-items: center;
    gap: 15px;
    text-align: left;
  }
  
  .process-card {
    width: 70px;
    height: 70px;
    margin: 0;
  }
  
  .process-item-text {
    flex: 1;
    padding: 0;
  }
  
  .process-name {
    font-size: 14px;
    margin-bottom: 5px;
  }
  
  .process-desc {
    font-size: 12px;
    line-height: 1.5;
    padding: 0;
  }
  
  .process-arrow {
    transform: rotate(90deg);
    margin: 0;
    font-size: 24px;
  }
  
  /* 旧流程样式 */
  .flow-steps {
    flex-direction: column;
    align-items: center;
    gap: 20px;
  }
}

@media (max-width: 480px) {
  .pro-banner {
    height: 200px;
  }
  
  .section-label {
    font-size: 18px;
  }
  
  .section-heading {
    font-size: 20px;
  }
  
  .content-img {
    width: 140px;
  }
  
  .category-item {
    max-width: 280px;
  }
  
  .category-item img {
    height: 280px;
  }
  
  .four-grid {
    gap: 20px;
  }
  
  .four-item {
    width: calc(50% - 20px);
  }
  
  .four-item img {
    height: 120px;
  }
  
  .four-name {
    font-size: 14px;
  }
  
  .process-item {
    max-width: 100%;
    flex-direction: column;
    text-align: center;
    align-items: center;
  }
  
  .process-card {
    width: 60px;
    height: 60px;
    margin-bottom: 10px;
  }
  
  .process-item-text {
    text-align: center;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/coms.vue